import React from 'react';

export default {
    fields: [
        {
            type: 'text',
            name: 'permalink',
            props: {
                label: <p><i className="asterisk icon inline"/>Break Permalink</p>,
                helpContent: '',
                helpHeader: '',
                required: true,
                validationRules: [
                    {
                        type: 'PermalinkFormat'
                    }
                ]
            }
        },
        {
            type: "radio",
            name: "sponsoredType",

            props: {
                label: <p><i className="asterisk icon inline"/>What kind of break?</p>,
                options: [
                    {key: 'editorial', text: 'Editorial', value: 'Editorial'},
                    {key: 'sponsored', text: 'Sponsored', value: 'Sponsored'}
                ]
            }
        },
        // {
        //     type: "langRadioOptions",
        //     name: "lang",

        //     props: {
        //         label: <p><i className="asterisk icon inline"/>Which site?</p>,
        //     }
        // }
    ]
};


// WEBPACK FOOTER //
// ./public/components/break/createBreakFormConfig.js